// Restock notifier: after a minute on the page a dialog offers restock alerts by pack and size.
// It shows once per visit (?restock opens it at once); the form posts to the shop's customer form like the newsletter,
// with the chosen size and packs as tags. Any button with data-restock="<PACK name>" opens it at once with that pack ticked.
(() => {
  const DELAY = 60000, KEY = 'mp-restock-seen';
  const seen = () => { try { return sessionStorage.getItem(KEY) === '1'; } catch { return false; } };
  const remember = () => { try { sessionStorage.setItem(KEY, '1'); } catch {} };
  const forced = new URLSearchParams(location.search).has('restock');
  if (!window.HTMLDialogElement) return;

  // Theme: sizes, packs, logo and the shop's root URL come from window.MP (layout/theme.liquid).
  const shop = window.MP?.root ?? 'https://mysterypacks.de/';
  const sizes = window.MP?.restockSizes ?? ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];
  const packs = window.MP?.restockPacks ?? ['BASE', 'BASE UPGRADE', 'BASE | WMNS', 'AMÉRICA', 'GLOBE TROTTER', 'PRE MATCH', 'ICON', 'FUTURE STARS',
    'PARTY', 'SPECIAL', 'DORTMUND SPECIAL', 'MÜNCHEN SPECIAL', 'LEVERKUSEN SPECIAL', 'CRACKED ICE', 'Neue PROMO PACKS'];
  const chip = (type, name, value) =>
    `<label class="restock-chip"><input type="${type}" name="${name}" value="${value}"><span>${value}</span></label>`;

  const dialog = document.createElement('dialog');
  dialog.className = 'restock';
  dialog.setAttribute('aria-labelledby', 'restock-title');
  dialog.innerHTML = `
    <div class="restock-top"><img class="restock-logo" src="${window.MP?.assetBase ?? 'assets/'}logo.svg" alt="MysteryPacks"><button class="restock-close" type="button" aria-label="Schließen">×</button></div>
    <form class="restock-form" method="post" action="${shop}contact#restock" accept-charset="UTF-8"${window.MP ? '' : ' target="_blank"'}>
      <h2 id="restock-title" tabindex="-1" autofocus>RESTOCK <span>NOTIFYER</span></h2>
      <p class="restock-lead">Dein Pack ist ausverkauft? Wir schreiben dir, sobald es in deiner Größe wieder da ist.</p>
      <input type="hidden" name="form_type" value="customer">
      <input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="contact[tags]" value="">
      <div class="restock-fields">
        <input type="text" name="contact[first_name]" placeholder="Vorname" aria-label="Vorname" autocomplete="given-name" required>
        <input type="email" name="contact[email]" placeholder="E-Mail" aria-label="E-Mail" autocomplete="email" required>
      </div>
      <div class="restock-packs-head"><span id="restock-size-label">Deine Größe</span><button class="restock-more" type="button" aria-pressed="false">+ Zweite Größe</button></div>
      <div class="restock-sizes" role="radiogroup" aria-labelledby="restock-size-label">${sizes.map(s => `<label><input type="radio" name="size" value="${s}" required><span>${s}</span></label>`).join('')}</div>
      <input type="hidden" name="size2" value="">
      <div class="restock-packs-head"><span id="restock-packs-label">Welche Packs?</span><button class="restock-all" type="button">Alle auswählen</button></div><div class="restock-chips" role="group" aria-labelledby="restock-packs-label">${packs.map(p => chip('checkbox', 'pack', p)).join('')}</div>
      <button class="restock-submit" type="submit">Benachrichtige mich</button>
      <p class="restock-note">Kein Spam, nur eine Mail zum Restock.</p>
    </form>
    <div class="restock-done" hidden>
      <h2>Du stehst auf der Liste.</h2>
      <p class="restock-lead">Sobald dein Pack in deiner Größe zurück ist, bekommst du eine Mail.</p>
      <button class="restock-submit" type="button">Weiter stöbern</button>
    </div>`;
  document.body.append(dialog);

  const form = dialog.querySelector('form');
  const done = dialog.querySelector('.restock-done');
  const close = () => { remember(); document.documentElement.classList.remove('restock-lock'); dialog.classList.remove('is-open'); setTimeout(() => dialog.close(), 250); };
  dialog.querySelector('.restock-close').addEventListener('click', close);
  done.querySelector('button').addEventListener('click', close);
  dialog.addEventListener('cancel', e => { e.preventDefault(); close(); });
  dialog.addEventListener('click', e => { if (e.target === dialog) close(); });
  // Second size: once switched on, a click on another size marks it as the second one (lighter blue);
  // clicking it again or switching off clears it.
  const more = form.querySelector('.restock-more');
  const size2 = form.querySelector('[name="size2"]');
  const sizeCells = [...form.querySelectorAll('.restock-sizes label')];
  let secondMode = false;
  const paint = () => {
    sizeCells.forEach(l => l.classList.toggle('is-second', l.querySelector('input').value === size2.value));
    more.textContent = !secondMode ? '+ Zweite Größe' : size2.value ? '× Zweite Größe entfernen' : 'Zweite Größe antippen';
    more.setAttribute('aria-pressed', String(secondMode));
  };
  more.addEventListener('click', () => { secondMode = !secondMode; if (!secondMode) size2.value = ''; paint(); });
  sizeCells.forEach(cell => cell.addEventListener('click', e => {
    const input = cell.querySelector('input');
    const primary = form.querySelector('input[name="size"]:checked');
    if (!secondMode || !primary || input === primary) return;
    e.preventDefault();
    size2.value = size2.value === input.value ? '' : input.value;
    paint();
  }));
  form.querySelectorAll('input[name="size"]').forEach(r => r.addEventListener('change', () => {
    if (r.value === size2.value) { size2.value = ''; paint(); }
  }));
  const boxes = [...form.querySelectorAll('input[name="pack"]')];
  const all = form.querySelector('.restock-all');
  const syncAll = () => { all.textContent = boxes.every(b => b.checked) ? 'Keine auswählen' : 'Alle auswählen'; };
  all.addEventListener('click', () => { const on = !boxes.every(b => b.checked); boxes.forEach(b => { b.checked = on; }); syncAll(); });
  boxes.forEach(b => b.addEventListener('change', syncAll));
  form.addEventListener('submit', event => {
    const packs = [...form.querySelectorAll('input[name="pack"]:checked')].map(i => i.value);
    const size = form.querySelector('input[name="size"]:checked');
    const second = size2.value && size2.value !== size?.value ? size2.value : '';
    form.querySelector('[name="contact[tags]"]').value = ['restock', size && `size:${size.value}`, second && `size:${second}`, ...packs.map(p => `restock:${p}`)].filter(Boolean).join(', ');
    remember();
    const finish = () => { form.hidden = true; done.hidden = false; };
    const klaviyo = window.MP?.klaviyo;
    // Klaviyo (Theme settings › Klaviyo): same list and profile properties as the existing form MP-EMAIL-RESTOCK,
    // so the restock flows keep working: desired_packs (list of pack values) and required_size.
    if (form.dataset.fallback || !klaviyo?.key || !klaviyo.restock || !window.MP.klaviyoSubscribe) {
      setTimeout(finish, 0);
      return;
    }
    event.preventDefault();
    const properties = { desired_packs: packs.map(window.MP.klaviyoPackValue), required_size: size ? window.MP.klaviyoSize(size.value) : '' };
    if (second) properties.required_size_2 = window.MP.klaviyoSize(second);
    const button = form.querySelector('.restock-submit');
    button.disabled = true;
    window.MP.klaviyoSubscribe({
      list: klaviyo.restock,
      email: form.querySelector('[name="contact[email]"]').value.trim(),
      firstName: form.querySelector('[name="contact[first_name]"]').value.trim(),
      properties,
      source: 'Website Restock Notifyer'
    }).then(finish).catch(() => {
      // Klaviyo unreachable: send the Shopify customer form (tags) instead, so no sign-up is lost.
      form.dataset.fallback = '1';
      form.requestSubmit ? form.requestSubmit() : form.submit();
    }).finally(() => { button.disabled = false; });
  });

  const show = () => {
    form.hidden = false; done.hidden = true;
    dialog.showModal();
    document.documentElement.classList.add('restock-lock');
    requestAnimationFrame(() => dialog.classList.add('is-open'));
  };
  // Opened from a product page: tick that pack (added as a chip when it is not in the list yet).
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-restock]');
    if (!trigger || dialog.open) return;
    // Same short name as the list in layout/theme.liquid: last " | " part dropped, " PACK" removed.
    const wanted = trigger.dataset.size;
    if (wanted) form.querySelectorAll('input[name="size"]').forEach(r => { if (r.value.toUpperCase() === wanted.toUpperCase()) r.checked = true; });
    const parts = trigger.dataset.restock.split('|');
    const name = (parts.length > 1 ? parts.slice(0, -1).join('|') : parts[0]).replace(/\s+PACK\b/gi, '').replace(/\s+/g, ' ').trim();
    if (name) {
      let box = boxes.find(b => b.value.toUpperCase() === name.toUpperCase());
      if (!box) {
        form.querySelector('.restock-chips').insertAdjacentHTML('afterbegin', chip('checkbox', 'pack', name));
        box = form.querySelector('input[name="pack"]');
        boxes.unshift(box);
        box.addEventListener('change', syncAll);
      }
      box.checked = true;
      syncAll();
    }
    show();
  });

  // Wait for a calm moment: not while the cart or another dialog is open.
  const open = () => {
    if (seen() && !forced) return;
    if (document.querySelector('dialog[open], .cart-preview.is-open, body.cart-open')) { setTimeout(open, 10000); return; }
    show();
  };
  // Theme: the form posts in place; Shopify comes back with ?customer_posted=true#restock, then the thank-you shows.
  if (/customer_posted=true/.test(location.search) && location.hash === '#restock') {
    remember();
    show();
    form.hidden = true;
    done.hidden = false;
  } else if ((!seen() && window.MP?.restockAuto !== false) || forced) setTimeout(open, forced ? 0 : DELAY);
})();
